"use client";

import { QueryKey } from "@saas/account/config";
import { getOryAttributes, getOryCsrf } from "@saas/account/utils";
import { FetchError, queryClient } from "@saas/core";
import { QueryOptionsInterface } from "@saas/shared/utils";

import { kratos } from "../..";

import { RecoveryFlow } from "@ory/client";
import { useQuery } from "@tanstack/react-query";

export type UseForgotPasswordQueryData = RecoveryFlow;

export const useForgotPasswordQuery = <
  DerivedQueryData = UseForgotPasswordQueryData
>(
  options?: QueryOptionsInterface<UseForgotPasswordQueryData, DerivedQueryData>
) => {
  return useQuery<UseForgotPasswordQueryData, FetchError, DerivedQueryData>(
    [QueryKey.AUTH_FORGOT_PASSWORD],
    () => {
      return kratos.createBrowserRecoveryFlow().then(({ data }) => data);
    },
    {
      ...options,
      select: options?.select,
      enabled: options?.enabled,
    }
  );
};

export const invalidateUseForgotPasswordQuery = () => {
  return queryClient.invalidateQueries([QueryKey.AUTH_FORGOT_PASSWORD]);
};

export const getForgotPasswordFormData = ({ id, ui }: RecoveryFlow) => ({
  id,
  csrfToken: getOryCsrf(ui.nodes),
  method: getOryAttributes(ui.nodes, "method"),
  error: ui?.messages?.[0],
});

export const useForgotPasswordFormQuery = () => {
  return useForgotPasswordQuery({ select: getForgotPasswordFormData });
};

export default useForgotPasswordQuery;
